import { useLocalStorage } from 'react-use';

export default useLocalStorage;
